// extracted by mini-css-extract-plugin
export default {"notFoundPage":"f6AA8Nie","container":"YvfJW5sL"};